import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import {
  CustomEnums,
  getCustomEnumName,
} from "../../utilities/src/CustomBlockHelpers";

// Customizable Area Start
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  name: string;
  hours: number;
  color: string;
  isActive: boolean;
  loading: boolean;
  configId: string;
  // Customizable Area End
}

interface SS {
  id: any;
  // Customizable Area Start
  // Customizable Area End
}

export default class ViewLateDeliveryConfigController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  getLateDeliveryConfigCallId: string = "";
  configId: string = "";
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.AccoutLoginSuccess),
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage),
    ];

    this.state = {
      // Customizable Area Start
      name: "",
      hours: 0,
      color: "#000000",
      isActive: false,
      loading: true,
      configId: "",
      // Customizable Area End
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    // Customizable Area Start
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    runEngine.debugLog("Message Recived", message);

    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );

      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      const errorReponse = message.getData(
        getName(MessageEnum.RestAPIResponceErrorMessage)
      );

      if (apiRequestCallId === this.getLateDeliveryConfigCallId) {
        console.log("=== RECEIVED API RESPONSE ===");
        console.log("Response:", responseJson);

        if (responseJson && !responseJson.errors && responseJson.data && responseJson.data.attributes) {
          const config = responseJson.data;
          console.log("Parsing config data:", config);
          this.setState({
            name: config.attributes.name || "",
            hours: config.attributes.hours || 0,
            color: config.attributes.color || "#000000",
            isActive: config.attributes.is_active || false,
            loading: false,
          });
          console.log("State updated successfully");
        } else {
          console.error("=== API ERROR ===");
          console.error("Invalid response or error:", responseJson);
          this.setState({ loading: false });
          if (responseJson && responseJson.errors) {
            this.parseApiErrorResponse(responseJson);
          }
        }
      }
    }
    // Customizable Area End
  }

  // Customizable Area Start
  async componentDidMount() {
    const configId = this.props.navigation.getParam("id", "");
    console.log("=== VIEW COMPONENT DID MOUNT ===");
    console.log("Received ID from navigation:", configId);
    console.log("Navigation object:", this.props.navigation);

    if (!configId) {
      console.error("No ID provided! Cannot fetch config.");
      this.setState({ loading: false });
      alert("Error: No configuration ID provided");
      return;
    }

    this.setState({
      configId: configId,
    });
    this.configId = configId;
    console.log("About to call getLateDeliveryConfig with ID:", this.configId);
    this.getLateDeliveryConfig();
  }

  componentDidUpdate(prevProps: Props, prevState: S) {
    if (prevState.configId !== this.state.configId) {
      this.configId = this.state.configId;
      this.getLateDeliveryConfig();
    }
  }

  getLateDeliveryConfig = () => {
    console.log("=== GET LATE DELIVERY CONFIG ===");
    console.log("Config ID:", this.configId);

    if (!this.configId) {
      console.error("Cannot fetch - no config ID!");
      this.setState({ loading: false });
      return;
    }

    this.setState({ loading: true });

    const endpoint = `${configJSON.LateDeliveryListPage.ApiUrls.getLateDeliveryList}/${this.configId}`;
    console.log("API Endpoint:", endpoint);

    const header = {
      "Content-Type": configJSON.validationApiContentType,
      token: localStorage.getItem("token"),
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getLateDeliveryConfigCallId = requestMessage.messageId;
    console.log("Request Message ID:", requestMessage.messageId);

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      endpoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );

    console.log("Sending API request...");
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleNavigateBack = () => {
    this.props.navigation.navigate("LateDeliveryList");
  };

  handleEdit = () => {
    this.props.navigation.navigate("EditLateDeliveryConfig", {
      id: this.configId,
    });
  };
  // Customizable Area End
}
